export class UpdatePasswordCommand {
    email: string = null;
    senhaNova: string = null;
          
      constructor(values: Partial<UpdatePasswordCommand> = { }) {
    
      Object.assign(this, values)
      }
    }
    